import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { AnonymousGuard } from "../guards/anonymous.guard";
import { PinGuard } from "../guards/pin.guard";

// import { ShopComponent } from '../shop/shop.component';
import { OrderPageComponent } from "../pages/order-page/order-page.component";
import { AccountPageComponent } from "../pages/account-page/account-page.component";
import { AccountCreatePageComponent } from "../pages/account-create-page/account-create-page.component";
import { ZoomPageComponent } from "../pages/zoom-page/zoom-page.component";
import { ShopPageComponent } from "../pages/shop-page/shop-page.component";
import { AnonShopPageComponent } from "../pages/anon-shop-page/anon-shop-page.component";
import { SuperShopPageComponent } from "../pages/super-shop-page/super-shop-page.component";
import { ZoomAfspraakPageComponent } from "../pages/zoom-afspraakpage/zoom-afspraakpage.component";
import { AfspraakPageComponent } from "../pages/afspraakpage/afspraakpage.component";

import { InstructionsPageComponent } from "../pages/instructions-page/instructions-page.component";
import { OrthokitPageComponent } from "../pages/orthokit-page/orthokit-page.component";
import { IdsPageComponent } from "../pages/ids-page/ids-page.component";

import { AssetsPageComponent } from "../pages/assets-page/assets-page.component";
import { LoginPageComponent } from "../pages/login-page/login-page.component";
import { HomePageComponent } from "../pages/home-page/home-page.component";

import { VoucherPageComponent } from "../pages/voucher-page/voucher-page.component";
import { DentalExpoPageComponent } from "../pages/dentalexpo-page/dentalexpo-page.component";
import { ProtectiveCleanPageComponent } from "../pages/protective-clean-page/protective-clean-page.component";
import { AdminComponent } from "../components/admin/admin.component";
import { MeetingPageComponent } from "../components/meeting-page/meeting-page.component";

import { PinPageComponent } from "../pages/pin-page/pin-page.component";
import { IndexeddbpageComponent } from "../pages/indexeddbpage/indexeddbpage.component";
import { ExpertCleanPageComponent } from "../pages/expert-cleanpage/expert-cleanpage.component";

import { JcdPageComponent } from "../pages/jcd-page/jcd-page.component";
import { ExcentPageComponent } from "../pages/excent-page/excent-page.component";
// one component to rule them all !
import { ContentPageComponent } from "../pages/content-page/content-page.component";
import { HomePageNewComponent } from "../pages/home-page-new/home-page-new.component";
import { PoetsplanKindComponent } from "../pages/poetsplan-kind/poetsplan-kind.component";
import { InstructieComponent } from "../pages/instructie/instructie.component";
import { ZoomComponent } from "../pages/zoom/zoom.component";
import { ExcentComponent } from "../pages/excent/excent.component";
import { TandenborstelsPageComponent } from "../pages/tandenborstels-page/tandenborstels-page.component";
import { OpzetborstelsPageComponent } from "../pages/opzetborstels-page/opzetborstels-page.component";


import { environment } from "../../environments/environment";
import { AccountRequestPageComponent } from "../pages/account-request-page/account-request-page.component";

export var mainRoutes: Routes = [
  { path: "", component: HomePageComponent }, 
  
  { path: "login", component: LoginPageComponent },
  { path: "signup/:uid/:token", component: LoginPageComponent }, // signup links
  { path: "reset/:email/:token", component: LoginPageComponent }, // reset links
  { path: "unsubscribe/:email/:t/:r/:h", component: LoginPageComponent }, // unsubscribefrom emails
  { path: "create", component: AccountCreatePageComponent },
  { path: "request", component: AccountRequestPageComponent },

  { path: "confirm_order/:oid/:h/:s", component: AccountPageComponent }, // account create and order confirmation
  { path: "auto_login/:oid/:h/:s", component: AccountPageComponent }, //
  { path: "start_meeting/:oid/:h/:s", component: AccountPageComponent }, // a moderator can auto login en start a meeting
  { path: "join_meeting/:mid", component: MeetingPageComponent }, // PUBLIC meeting start page

  { path: "moderate_meeting/:mid", component: MeetingPageComponent }, // PUBLIC meeting start page
  { path: "moderate_meeting/:mid/", component: MeetingPageComponent }, // PUBLIC meeting start page
  { path: "moderate_meeting/:mid/:email", component: MeetingPageComponent }, // PUBLIC meeting start page
  { path: "moderate_meeting/:mid/:email/:pin", component: MeetingPageComponent }, // PUBLIC meeting start page

  { path: "account", component: AccountPageComponent, canActivate: [AuthGuard] },
  { path: "account/create", component: AccountCreatePageComponent },
  { path: "orders", component: OrderPageComponent, canActivate: [AuthGuard] },
  { path: "activate/:code", component: AccountCreatePageComponent }, // autofill create page
  { path: "zoom", component: ZoomComponent },
  { path: "zoomafspraak", component: ZoomAfspraakPageComponent }, // TODO: refactor to general page using CMS
  { path: "gefeliciteerd", component: AfspraakPageComponent },

  { path: "dentalexpo", component: DentalExpoPageComponent },
  { path: "protectiveclean", component: ProtectiveCleanPageComponent },
  { path: "instructie", component: InstructieComponent },
  // { path: "orthokit", component: OrthokitPageComponent },
  { path: "pin", component: PinPageComponent },
  { path: "expertclean", component: ExpertCleanPageComponent },

  { path: "jcd", component: JcdPageComponent },
  { path: "excent", component: ExcentComponent },
  { path: "swissdentalprint", component: ExcentComponent },
  { path: "homepagenew", component: HomePageNewComponent },
  { path: "poetsplankind", component: PoetsplanKindComponent },
  { path: "sonicareforkids", component: PoetsplanKindComponent }, 
  { path: "instructiepakketten", component: InstructieComponent },
  { path: "patienten-testprogramm", component: InstructieComponent },
  { path: "zoom-new", component: ZoomComponent },
  { path: "excent-new", component: ExcentComponent },
  { path: "tandenborstels", component: TandenborstelsPageComponent },
  { path: "schallzahnbuersten", component: TandenborstelsPageComponent },
  { path: "opzetborstels", component: OpzetborstelsPageComponent },
  { path: "buerstenkoepfe", component: OpzetborstelsPageComponent },

  { path: 'news/poetsplan-kind',   redirectTo: 'poetsplankind', pathMatch: 'full' },
  { path: 'news/tandenborstels',   redirectTo: 'tandenborstels', pathMatch: 'full' },
  { path: 'news/opzetborstels',   redirectTo: 'opzetborstels', pathMatch: 'full' },
  { path: 'news/zoom',   redirectTo: 'zoom', pathMatch: 'full' },

  // GENERAL CONTENT PAGES (todo should replace all custom pages)
  { path: "p/:page", component: ContentPageComponent }, // general prefix
  { path: "news/:page", component: ContentPageComponent }, // special path for news
  { path: "news", component: ContentPageComponent, data: { page: "NEWS" } }, // special path for index
  { path: "FAQ", component: ContentPageComponent, data: { page: "FAQ" } }, // special path for FAQ

  { path: "vouchers", component: VoucherPageComponent, canActivate: [AuthGuard] },

  { path: "orderadmin", component: AdminComponent },
  { path: "smarttalks/vermaire", component: AdminComponent },

  { path: "shop", component: ShopPageComponent, canActivate: [AuthGuard] },
  { path: "shop/detail/:pid", component: ShopPageComponent, canActivate: [AuthGuard]} ,

  { path: "bestellen/op/de/beurs/:pid", component: SuperShopPageComponent,  canActivate: [AnonymousGuard]},
  { path: "ids/:pid", component: IdsPageComponent, canActivate: [AnonymousGuard, PinGuard] },
  // { path: 'trade-show/:pid', component: IdsPageComponent, canActivate: [AnonymousGuard, PinGuard] },
  { path: "trade-show/:pid", component: IdsPageComponent, canActivate: [AnonymousGuard] },

  // { path: "indexeddb",component: IndexeddbpageComponent, canActivate: [PinGuard] },
  // { path: 'my-orders', component: IndexeddbpageComponent, canActivate: [PinGuard] },
  { path: "my-orders", component: IndexeddbpageComponent },

  { path: "bestellen", component: AnonShopPageComponent, canActivate: [AnonymousGuard] },
  { path: "commander", component: AnonShopPageComponent, canActivate: [AnonymousGuard] },
  { path: "commande", component: AnonShopPageComponent, canActivate: [AnonymousGuard] },

  { path: "assetlibrary", component: AssetsPageComponent },
  { path: "assetlibrary/:type", component: AssetsPageComponent },
  { path: "assetlibrary/preview/:pid", component: AssetsPageComponent },
  { path: "assetlibrary/preview/:pid/:print", component: AssetsPageComponent },
  // ALIAS for clinical studies
  { path: "studies", component: AssetsPageComponent },
  { path: "clinical/:type", component: AssetsPageComponent },
  { path: "clinical/preview/:pid", component: AssetsPageComponent },
  { path: "clinical/preview/:pid/:print", component: AssetsPageComponent },

  { path: "**", redirectTo: "", component: LoginPageComponent }, // untill we have a decent 404
];

@NgModule({
  // imports: [CommonModule, RouterModule.forRoot(homeRoutes.concat(mainRoutes))],
  imports: [CommonModule, RouterModule.forRoot(mainRoutes)],
  providers: [AuthGuard, AnonymousGuard, PinGuard],
  exports: [RouterModule],
  declarations: [],
})
export class RoutingModule {}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/routing/routing.module.ts